export default {"src":"/_next/static/media/btcd.2a3aa90c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};